import * as React from 'react';

import { Nullable } from '@common/typescript/objects/Nullable';

import {
	StatusSelectFilter,
} from '@app/store/SelectList/SelectsInterfaces';
import {
	CoreSelect,
	CoreSelectProps,
} from '@app/components/UI/Inputs/CoreSelect';
import { SelectRequestParams } from '@app/store/SelectList/ListActions';

interface BaseProps {
	crematoryId?: number;
	disabled?: boolean;
	className?: string;
	selectClassName?: string;
	activeClassName?: string;

	pickDefault?: (entity) => number;
	onDeselect?: (id: number) => void;
	onSelect?: (id: number) => void;

	label?: string;
	placeholder?: string;
}

interface SingleProps extends BaseProps {
	value?: number;
	onChange: (value: number | undefined) => void;
	multiple?: false;
}

interface MultipleProps extends BaseProps {
	value?: Array<number>;
	onChange: (value: Array<number> | undefined) => void;
	multiple: true;
}

type OwnProps = SingleProps | MultipleProps;

interface RequestParams extends SelectRequestParams<number> {
	crematoryId: number;
}

function isEmptyValue(value?: number | Array<number>) {
	if (value === undefined) return true;
	if (Array.isArray(value)) return value.length === 0;

	return value === -1;
}

function shouldPickDefault(
	store,
	multiple,
	isEmptyValue,
	reqProps,
	value,
): boolean {
	return !store.isLoading
		&& store.items?.length && store.pagination.total === 1
		// eslint-disable-next-line sonarjs/no-all-duplicated-branches
		&& (multiple ? isEmptyValue?.(value) : isEmptyValue?.(value))
		&& reqProps.isEmpty(store.filters);
}

export const StatusSelect = (props: OwnProps): JSX.Element => {
	const [query, setQuery] = React.useState<string>('');
	const filters: Nullable<StatusSelectFilter> = React.useMemo(() => ({
		name: query,
		search: query,
	}), [query]);

	const reqParams: Partial<RequestParams> = React.useMemo(() => ({
		crematoryId: props.crematoryId,
	}), [props.crematoryId]);

	const properties: CoreSelectProps<number, 'status', RequestParams> = {
		...props,
		onSearch: setQuery,
		filters,
		reqParams,
		shouldPickDefault,
		isEmptyValue,
		store: 'status',
	};

	return <CoreSelect {...properties} />;
};
